module.exports = __webpack_public_path__ + "static/media/6-ano.fca350d3.png";